import './style/title-editor.less';
import TitleEditor from './TitleEditor';

export default TitleEditor;
